import { render, staticRenderFns } from "./carousel-canvas.vue?vue&type=template&id=b21c8dd8"
import script from "./carousel-canvas.vue?vue&type=script&lang=js"
export * from "./carousel-canvas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports